import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 32,
  medium: 21,
  small: 15,
  xSmall: 12
};
const FilterIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12.5025C18.7917 12.5309 17.7375 11.6876 17.5 10.5025H4.5V9.50251H17.5C17.7366 8.33734 18.7611 7.5 19.95 7.5C21.1389 7.5 22.1634 8.33734 22.4 9.50251H25.5V10.5025H22.45C22.2159 11.6688 21.1896 12.5067 20 12.5025ZM20 8.50293C19.1716 8.50293 18.5 9.1745 18.5 10.0029C18.5 10.8314 19.1716 11.5029 20 11.5029C20.8284 11.5029 21.5 10.8314 21.5 10.0029C21.5 9.1745 20.8284 8.50293 20 8.50293Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 19.5278C7.7264 18.3507 8.75636 17.5 9.955 17.5C11.1536 17.5 12.1836 18.3507 12.41 19.5278H25.5V20.5278H12.45C12.2556 21.7579 11.1854 22.6572 9.94026 22.6371C8.69509 22.617 7.65459 21.6835 7.5 20.4478H4.5V19.4478L7.5 19.5278ZM9.95996 21.5273C10.7884 21.5273 11.46 20.8558 11.46 20.0273C11.46 19.1989 10.7884 18.5273 9.95996 18.5273C9.13153 18.5273 8.45996 19.1989 8.45996 20.0273C8.46517 20.4287 8.63103 20.8113 8.92045 21.0894C9.20987 21.3675 9.5987 21.5181 9.99996 21.5073L9.95996 21.5273Z",
        fill: "currentColor"
      }
    )
  );
};
FilterIcon.iconName = "FilterIcon";

export { FilterIcon };
